import React, { FC } from "react";
import { GroupsView } from "../components";

export const GroupsPage: FC = () => {
  return <GroupsView />;
};
